import { gql } from '@apollo/client';

const EXTEND_ACTIVE_SESSION_MUTATION = gql`
  mutation extendActiveSession {
    extendActiveSession {
      isSuccess
      message
    }
  }
`;

export default EXTEND_ACTIVE_SESSION_MUTATION;
